<div class="state">
    <svg focusable="false">
        <path d="m4.7 9.6l6-6-1-1-5 5.1-2.4-2.4-1 1 3.4 3.3z"/>
    </svg>
</div>
<ng-content></ng-content>